import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';

import 'assets/css/rating.css'
import { httpOk, post } from 'helpers/api';

function Index() {
	const { pos_id, cheque_order_type_id, transaction_id } = useParams()

	const [showSuccess, setShowSuccess] = useState(false)
	const [data, setData] = useState([])

	async function createRating() {
		var sendData = {
			'pos_id': pos_id,
			'cheque_order_type_id': cheque_order_type_id,
			'transaction_id': transaction_id,
			'answers': [],
		}
		sendData.answers = data
		const response = await post('/openapi/answers', sendData)
		if (httpOk(response)) setShowSuccess(true)
	}

	function changeRateable(index, index2) {
		const dataCopy = [...data]
		for (let i = 0; i < dataCopy[index].options.length; i++) {
			dataCopy[index].options[i].selected = false
		}
		dataCopy[index].options[index2].selected = !dataCopy[index].options[index2].selected
		setData(dataCopy)
	}

	function changeSelectable(index, index2) {
		const dataCopy = [...data]
		dataCopy[index].options[index2].selected = !dataCopy[index].options[index2].selected
		setData(dataCopy)
	}

	function changeRadio(index, index2) {
		const dataCopy = [...data]
		for (let i = 0; i < dataCopy[index].options.length; i++) {
			dataCopy[index].options[i].selected = false
		}
		dataCopy[index].options[index2].selected = !dataCopy[index].options[index2].selected
		setData(dataCopy)
	}

	function changeCheckbox(index, index2) {
		const dataCopy = [...data]
		dataCopy[index].options[index2].selected = !dataCopy[index].options[index2].selected
		setData(dataCopy)
	}

	function changeTextarea(e, index) {
		const dataCopy = [...data]
		dataCopy[index].value = e.target.value
		setData(dataCopy)
	}

	async function getData() {
		var sendData = {
			'pos_id': pos_id,
			'cheque_order_type_id': cheque_order_type_id,
		}

		const response = await post(`/openapi/questions`, sendData)
		if (response) setData(response.data)
	}

	useEffect(() => {
		getData()
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{!showSuccess ?
				<>
					<div style={{ 'padding': '20px 20px 0 20px', 'marginBottom': '60px' }}>
						{data.map((item, index) => (
							<div className="rating-block" key={index}>
								<div className="question">
									{index + 1}. {item.name}
								</div>

								<div className="input_types">
									{item.input_type === "rateable" &&
										<div className="rateable">
											{item.options?.map((item2, index2) => (
												<div className="rateable-item " key={index2}
													onClick={() => changeRateable(index, index2)}
													style={{
														'color': item2.selected ? "#34b547" : 'inherit',
														'borderColor': item2.selected ? "#34b547" : '#757575',
													}}>
													<i className="uil-star"></i>
													<div>{item2.value}</div>
												</div>
											))}
										</div>
									}
									{item.input_type === "selectable" &&
										<div className="selectable">
											<div className="selectable-items">
												{item.options.map((item2, index2) => (
													<div className="selectable-item" key={index2} onClick={() => changeSelectable(index, index2)}
														style={{
															'color': item2.selected ? "#34b547" : 'inherit',
															'borderColor': item2.selected ? "#34b547" : '#757575',
														}}>
														{item2.value}
													</div>
												))}
											</div>
										</div>
									}
									{item.input_type === "radio" &&
										<div className="radio">
											{item.options.map((item2, index2) => (
												<div className="radio-item" key={index2} onClick={() => changeRadio(index, index2)}>
													<div className="custom-radio"
														style={{ 'backgroundColor': item2.selected ? "#34b547" : '#fff' }} />
													<label className="form-check-label" htmlFor={item2.value}>
														{item2.value}
													</label>
												</div>
											))}
										</div>
									}
									{item.input_type === "checkbox" &&
										<div className="checkbox">
											{item.options.map((item2, index2) => (
												<div className="checkbox-item" key={index2} onClick={() => changeCheckbox(index, index2)}>
													<div className="custom-checkbox"
														style={{ 'backgroundColor': item2.selected ? "#34b547" : '#fff' }} />
													<label className="form-check-label" htmlFor={item2.value}>
														{item2.value}
													</label>
												</div>
											))}
										</div>
									}
									{item.input_type === "textarea" &&
										<div className="textarea">
											<textarea name="value" className="form-control textarea-item" rows={6}
												onChange={(e) => changeTextarea(e, index)} />
										</div>
									}
								</div>
							</div>
						))}
					</div>
					<div style={{ 'position': 'absolute', 'bottom': '0px', 'width': '100%' }}>
						<button className="feedback-button justify-content-center"
							onClick={() => createRating()}>
							OK
						</button>
					</div>
				</>
				:
				<div className="success-page">
					<div>
						<div>
							<i className="uil uil-check-square"></i>
						</div>
						<div>
							Спасибо за ваш отзыв
						</div>
						<span>
							Ваш отзыв был отправлен
						</span>
					</div>
				</div>
			}
		</>
	)
}

export default Index